import axios from "axios";

export class SettingsApi {
    static readonly KEY = 'settings';

    static async getSettingValue(setting: string): Promise<{ value: 'true' | 'false' }> {
        const {data} = await axios.get(`/api/v1/settings/${setting}`);
        return data.data;
    }

    static async setSettingValue<T>(params: { setting: string; value: T }): Promise<void> {
        const {data} = await axios.post(`/api/v1/settings/${params.setting}`, {
            value: params.value
        });
        return data.data;
    }
}